const PHONE_WITHOUT_COUNTRY_CODE_LENGTH = 10;

/** `79991234567` / `+9991234567` -> `+7 999 123-45-67` (legacy `shared/functions/format`). */
export const formatPhone = (phone: string | number | null | undefined): string => {
  if (!phone) return '';
  const digits = String(phone).replace('+', '');
  const withCountryCode = digits.length === PHONE_WITHOUT_COUNTRY_CODE_LENGTH ? `7${digits}` : digits;
  return withCountryCode.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 $2 $3-$4-$5');
};
